import React from "react";
import { useSite } from "../contexts/SiteContext";
import { resolveAssetUrl } from "../lib/api";

const Levels = () => {
  const { content } = useSite();
  const levels = content.levels || { items: [] };
  return (
    <section id="niveles" style={{ padding: "60px 24px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div className="fade-in" style={{ marginBottom: 44, maxWidth: 760 }}>
          <span className="pill" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#1A1352" }} /> {levels.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(34px, 4.6vw, 60px)", margin: "12px 0 16px" }}>
            {levels.titleLine1}<br />
            <span className="text-grad-purple">{levels.titleLine2Highlight}</span>{levels.titleLine2Suffix}
          </h2>
          <p style={{ color: "#5F5A72", fontSize: 16, lineHeight: 1.55, maxWidth: 620 }}>{levels.subtitle}</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 22 }}>
          {(levels.items || []).map((lv, idx) => (
            <article key={idx} className="card-soft fade-in" style={{ display: "flex", flexDirection: "column" }}>
              <div className="img-zoom-wrap" style={{ aspectRatio: "4/3", position: "relative" }}>
                <img src={resolveAssetUrl(lv.image)} alt={lv.title} className="img-zoom" />
                <span style={{ position: "absolute", top: 14, left: 14, background: "rgba(255,255,255,0.95)", color: "#1A1352", fontWeight: 700, fontSize: 11, padding: "4px 10px", borderRadius: 999 }}>{lv.code}</span>
              </div>
              <div style={{ padding: 22, display: "flex", flexDirection: "column", gap: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                  <h3 className="h-display" style={{ fontSize: 22, margin: 0 }}>{lv.title}</h3>
                  <span style={{ color: "#FF4F1A", fontWeight: 700, fontSize: 13 }}>{lv.n}</span>
                </div>
                <p style={{ color: "#5F5A72", fontSize: 13.5, lineHeight: 1.55, margin: 0 }}>{lv.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Levels;
